"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonScheduleControlInteractor = void 0;
require("@veeam/components");
const core_1 = require("@veeam/core");
const helpers_1 = require("./helpers");
const types_1 = require("./types");
class CommonScheduleControlInteractor extends core_1.Interactor {
    constructor(controlModel, texts, columns) {
        super();
        this.controlModel = controlModel;
        this.texts = texts;
        this.columns = columns;
        this.getScheduleData = () => {
            const modelValue = this.controlModel.getValue();
            return [
                modelValue.rowFirstScheduleValue,
                modelValue.rowSecondScheduleValue,
                modelValue.rowThirdScheduleValue,
            ];
        };
        this.getScheduleRowFieldName = (rowIndex) => {
            let fieldName = 'rowFirstScheduleValue';
            switch (rowIndex) {
                case types_1.SCHEDULE_ROW_INDEX.second:
                    fieldName = this.isRowSecondScheduleVisible()
                        ? 'rowSecondScheduleValue'
                        : 'rowThirdScheduleValue';
                    break;
                case types_1.SCHEDULE_ROW_INDEX.third:
                    fieldName = 'rowThirdScheduleValue';
                    break;
            }
            return fieldName;
        };
        this.handleUpdateMatrixData = (value) => {
            const scheduleData = this.getScheduleData();
            for (let i = 0; i < scheduleData.length; i++) {
                for (let j = 0; j < scheduleData[i].length; j++) {
                    this.controlModel.update((modelVal) => {
                        const fieldName = this.getScheduleRowFieldName(i);
                        modelVal[fieldName] = value[i];
                    });
                }
            }
        };
        this.handleSelectTileMatrix = (items, isSelected) => {
            items.forEach(({ rowIndex, columnIndex }) => {
                const fieldName = this.getScheduleRowFieldName(rowIndex);
                let modelValue = this.controlModel.getValue();
                const scheduleValue = [...modelValue[fieldName]];
                const newScheduleValue = [...scheduleValue];
                newScheduleValue[columnIndex] = isSelected;
                this.controlModel.update((value) => {
                    value[fieldName] = [...newScheduleValue];
                });
                if (rowIndex !== types_1.SCHEDULE_ROW_INDEX.first && isSelected) {
                    this.controlModel.update((value) => {
                        value.rowFirstScheduleValue[columnIndex] = isSelected;
                    });
                }
                if (rowIndex === types_1.SCHEDULE_ROW_INDEX.first && !isSelected) {
                    this.controlModel.update((value) => {
                        value.rowFirstScheduleValue[columnIndex] = isSelected;
                        value.rowSecondScheduleValue[columnIndex] = isSelected;
                        value.rowThirdScheduleValue[columnIndex] = isSelected;
                    });
                }
            });
        };
        this.getMatrixData = (filledColumns, filledColumnsBySelectedDays) => {
            const modelValue = this.controlModel.getValue();
            const matrixData = [...helpers_1.getEmptyRows()];
            const emptyColumns = helpers_1.getEmptyColumns(this.columns.length);
            matrixData[types_1.SCHEDULE_ROW_INDEX.first] = modelValue.isRowFirstScheduleEnabled
                ? filledColumnsBySelectedDays || filledColumns
                : emptyColumns;
            matrixData[types_1.SCHEDULE_ROW_INDEX.second] = modelValue.isRowSecondScheduleEnabled
                ? filledColumns
                : emptyColumns;
            matrixData[types_1.SCHEDULE_ROW_INDEX.third] = modelValue.isRowThirdScheduleEnabled
                ? filledColumns
                : emptyColumns;
            return matrixData;
        };
        this.handleSelectAll = () => {
            const countColumn = this.columns.length;
            let newMatrixData = [...helpers_1.getEmptyRows()];
            const filledColumns = helpers_1.getFilledColumns(countColumn);
            // if (modelValue.fieldKindValue === DAILY_SCHEDULE_KINDS.everyday) {
            newMatrixData = this.getMatrixData(filledColumns);
            this.handleUpdateMatrixData(newMatrixData);
        };
        this.getScheduleRowsVisibilityData = () => {
            const data = {
                [types_1.SCHEDULE_ROW.first]: this.isRowFirstScheduleVisible(),
                [types_1.SCHEDULE_ROW.second]: this.isRowSecondScheduleVisible(),
                [types_1.SCHEDULE_ROW.third]: this.isRowThirdScheduleVisible(),
            };
            return data;
        };
        this.isRowFirstScheduleVisible = () => {
            return this.controlModel.getValue().isRowFirstScheduleEnabled;
        };
        this.isRowFirstFieldCountVisible = () => {
            // !isEfsPolicy
            return this.controlModel.getValue().isRowFirstScheduleEnabled;
        };
        this.isRowFirstFieldCountDisabled = () => {
            const modelValue = this.controlModel.getValue();
            return (
            // !modelValue.isRowSecondScheduleVisible &&
            // !isEfsPolicy
            !this.isRowFirstScheduleVisible() ||
                CommonScheduleControlInteractor.isScheduleDisabled(modelValue.rowFirstScheduleValue));
        };
        this.isRowSecondScheduleVisible = () => {
            return this.controlModel.getValue().isRowSecondScheduleEnabled;
        };
        this.isRowSecondFieldCountVisible = () => {
            // !isEfsPolicy && isRemoteSnapshotEnabled
            return (this.isRowSecondScheduleVisible() && this.controlModel.getValue().isRowSecondScheduleEnabled);
        };
        this.isRowSecondFieldCountDisabled = () => {
            // return true; // temp
            // !isEfsPolicy && (!isRemoteSnapshotEnabled || isScheduleDisabled(remoteSnapshotScheduleData))
            const modelValue = this.controlModel.getValue();
            return (!modelValue.isRowSecondScheduleEnabled ||
                CommonScheduleControlInteractor.isScheduleDisabled(modelValue.rowSecondScheduleValue));
        };
        this.isRowThirdScheduleVisible = () => {
            return this.controlModel.getValue().isRowThirdScheduleEnabled;
        };
        this.isRowThirdFieldCountAndTypeVisible = () => {
            // isEc2Policy && isBackupEnabled && !(isMonthly && isGlacierEnabled)
            const controlModelValue = this.controlModel.getValue();
            return (controlModelValue.isRowThirdScheduleEnabled && controlModelValue.isRowThirdScheduleEnabled);
        };
        this.isRowThirdFieldCountDisabled = () => {
            // isEc2Policy && (!isBackupEnabled || isScheduleDisabled(backupScheduleData))
            const modelValue = this.controlModel.getValue();
            return (!modelValue.isRowThirdScheduleEnabled ||
                CommonScheduleControlInteractor.isScheduleDisabled(modelValue.rowThirdScheduleValue));
        };
        this.isRowFirstFieldTypeDisabled = () => {
            const modelValue = this.controlModel.getValue();
            return CommonScheduleControlInteractor.isRowFieldTypeDisabled(modelValue.isRowFirstScheduleEnabled, modelValue.rowFirstScheduleValue);
        };
        this.isRowSecondFieldTypeDisabled = () => {
            const modelValue = this.controlModel.getValue();
            return CommonScheduleControlInteractor.isRowFieldTypeDisabled(modelValue.isRowSecondScheduleEnabled, modelValue.rowSecondScheduleValue);
        };
        this.isRowThirdFieldTypeDisabled = () => {
            const modelValue = this.controlModel.getValue();
            return CommonScheduleControlInteractor.isRowFieldTypeDisabled(modelValue.isRowThirdScheduleEnabled, modelValue.rowThirdScheduleValue);
        };
        this.isRowFirstFieldTypeVisible = () => {
            const modelValue = this.controlModel.getValue();
            return modelValue.isRowFirstFieldTypeVisible;
        };
        this.isRowSecondFieldTypeVisible = () => {
            const modelValue = this.controlModel.getValue();
            return modelValue.isRowSecondFieldTypeVisible;
        };
        this.isRowThirdFieldTypeVisible = () => {
            const modelValue = this.controlModel.getValue();
            return modelValue.isRowThirdFieldTypeVisible;
        };
        this.getScheduleRetentionTypeOptions = () => {
            return helpers_1.getTextOptionsList(helpers_1.getRetentionTypeList(), this.texts);
        };
        this.controlModel = controlModel;
        this.columns = columns;
        this.initialRowFirstScheduleValue = controlModel.getValue().rowFirstScheduleValue;
        this.initialRowSecondScheduleValue = controlModel.getValue().rowSecondScheduleValue;
        this.initialRowThirdScheduleValue = controlModel.getValue().rowThirdScheduleValue;
    }
    handleClearAll() {
        const newMatrixData = [...helpers_1.getEmptyRows()];
        newMatrixData[types_1.SCHEDULE_ROW_INDEX.first] = helpers_1.getEmptyColumns(this.columns.length);
        newMatrixData[types_1.SCHEDULE_ROW_INDEX.second] = helpers_1.getEmptyColumns(this.columns.length);
        newMatrixData[types_1.SCHEDULE_ROW_INDEX.third] = helpers_1.getEmptyColumns(this.columns.length);
        this.handleUpdateMatrixData(newMatrixData);
    }
    handleReset() {
        this.handleUpdateMatrixData([
            [...this.initialRowFirstScheduleValue],
            [...this.initialRowSecondScheduleValue],
            [...this.initialRowThirdScheduleValue],
        ]);
    }
}
exports.CommonScheduleControlInteractor = CommonScheduleControlInteractor;
CommonScheduleControlInteractor.isScheduleDisabled = (scheduleData) => {
    return scheduleData.every((value) => !value);
};
CommonScheduleControlInteractor.isRowFieldTypeDisabled = (isRowScheduleEnabled, scheduleValue) => {
    return (!isRowScheduleEnabled || CommonScheduleControlInteractor.isScheduleDisabled(scheduleValue));
};
CommonScheduleControlInteractor.getRowFirstScheduleValueValidation = (errorText) => {
    return [helpers_1.requiredSchedule(errorText)];
};
CommonScheduleControlInteractor.getRowFirstFieldCountValueValidation = (minCount, maxCount) => {
    return [core_1.required(), core_1.minNumber(minCount), core_1.maxNumber(maxCount)];
};
CommonScheduleControlInteractor.getRowSecondFieldCountValueValidation = (isScheduleEnabled, minCount, maxCount) => {
    return isScheduleEnabled ? [core_1.required(), core_1.minNumber(minCount), core_1.maxNumber(maxCount)] : undefined;
};
CommonScheduleControlInteractor.getRowThirdFieldCountValueValidation = (isScheduleEnabled, minCount, maxCount) => {
    return isScheduleEnabled ? [core_1.required(), core_1.minNumber(minCount), core_1.maxNumber(maxCount)] : undefined;
};
CommonScheduleControlInteractor.getRowThirdFieldTypeValue = (isScheduleEnabled) => {
    return isScheduleEnabled ? [core_1.required()] : undefined;
};
CommonScheduleControlInteractor.getScheduleRowsValidations = (scheduleIsRequiredErrorText, isSecondRowExistingAndEnabled, isThirdRowExistingAndEnabled, rowFirstFieldCountMinValue, rowFirstFieldCountMaxValue, rowSecondFieldCountMinValue, rowSecondFieldCountMaxValue, rowThirdFieldCountMinValue, rowThirdFieldCountMaxValue) => {
    return {
        rowFirstScheduleValue: CommonScheduleControlInteractor.getRowFirstScheduleValueValidation(scheduleIsRequiredErrorText),
        rowFirstFieldCountValue: CommonScheduleControlInteractor.getRowFirstFieldCountValueValidation(rowFirstFieldCountMinValue, rowFirstFieldCountMaxValue),
        rowSecondFieldCountValue: CommonScheduleControlInteractor.getRowSecondFieldCountValueValidation(isSecondRowExistingAndEnabled, rowSecondFieldCountMinValue, rowSecondFieldCountMaxValue),
        rowThirdFieldCountValue: CommonScheduleControlInteractor.getRowThirdFieldCountValueValidation(isThirdRowExistingAndEnabled, rowThirdFieldCountMinValue, rowThirdFieldCountMaxValue),
        rowThirdFieldTypeValue: CommonScheduleControlInteractor.getRowThirdFieldTypeValue(isThirdRowExistingAndEnabled),
    };
};
//# sourceMappingURL=CommonScheduleControlInteractor.js.map